<template>
  <div class="intro-screen">
    <p
      class="upper-text"
      :style="fontFamily"
    >
      {{ title }}
    </p>
    <hr class="divider mt-n2 mb-4 pb-2 mx-3">
    <template v-if="intro">
      <p
        class="middle-text"
        :style="fontFamily"
      >
        Welcome to our livestream!
      </p>
      <p
        class="bottom-text"
        :style="fontFamily"
      >
        Hang tight, we’ll be with you shortly.
      </p>
    </template>
    <template v-else>
      <p
        class="middle-text"
        :style="fontFamily"
      >
        Thank you for joining today's livestream!
      </p>
      <p
        class="bottom-text"
        :style="fontFamily"
      >
        {{ 'For any questions, contact ' + contact }}
      </p>
    </template>
  </div>
</template>

<script>
export default {
  name: 'OfflineScreen',
  props: {
    institutionPk: {
      type: String,
      default: '',
    },
    fonts: {
      type: Array,
      default() {
        return [];
      },
    },
    title: {
      type: String,
      default: 'Livestream',
    },
    intro: {
      type: Boolean,
      default: true,
    },
    contact: {
      type: String,
      default: '',
    },
  },
  computed: {
    fontFamily() {
      const prop = {};
      prop['--institution-font-family'] = this.$store.state.fonts.items.length
        ? this.$store.state.fonts.items[0].font_family
        : '';
      return prop;
    },
  },
  mounted() {
    this.fonts.forEach((obj) => { obj.is_institution_default = obj.default; });
    this.$store.dispatch('fonts/updateFontData', this.fonts);
    this.$store.dispatch('fonts/injectFontsAnonymousUser', this.institutionPk);
  },
};
</script>

<style lang="scss">
.intro-screen {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.upper-text {
  font-family: var(--institution-font-family);
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 30px;
}
.middle-text {
  font-family: var(--institution-font-family);
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 24px;
}
.bottom-text {
  font-family: var(--institution-font-family);
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 20px;
}
.divider {
  width: 150%;
  border-top: transparent;
  border-bottom: 1px solid #ccc;
}
</style>
